import FinishGoodQcConfirmationDetail from '@/models/FinishGoodQcConfirmation/FinishGoodQcConfirmationDetail';

export default class FinishGoodQcConfirmationDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.finishGoodQcConfirmationId  = '';
		this.finishGoodQcConfirmationRequestNumber = '';
		this.finishGoodQualityInspectionId  = '';
		this.finishGoodQualityInspectionControlCard = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.partName = '';
		this.metodeQc = '';
		this.qtyBefore = '';
		this.qtyOk = '';
		this.qtyPending = '';
		this.qtyNg = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			finishGoodQcConfirmationId : '0',
			finishGoodQcConfirmationRequestNumber : '0',
			finishGoodQualityInspectionId : '0',
			finishGoodQualityInspectionControlCard : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			partId : '0',
			partPartNumber : '0',
			partName : '0',
			metodeQc : '0',
			qtyBefore : '0',
			qtyOk : '0',
			qtyPending : '0',
			qtyNg : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}